/**
 * Read a theme token's resolved value, for the few places CSS cannot reach:
 * a <canvas> fillStyle, a third-party chart that wants a literal. Everything
 * else should use the token in CSS (`var(--fd-…)` or a semantic Tailwind
 * colour), which follows a theme change on its own.
 *
 * Reads from `el` (default: <html>), so a value read inside a nested theme
 * scope is that scope's value. Call it when drawing, not once at import —
 * the theme can change while the page is open.
 */
export function readToken(name: `--${string}`, el: Element = document.documentElement): string {
    return getComputedStyle(el).getPropertyValue(name).trim();
}

/** The categorical chart palette (`--fd-chart-1` … `--fd-chart-8`). */
export const CHART_TOKENS = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `--fd-chart-${n}` as const);
